import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const merchant = {
  merchantList: (params) => {
    const url = api.merchant.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  merchantDetail: (merchantId) => {
    const url = api.merchant.detail(merchantId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  addMerchant: (payloads) => {
    const url = api.merchant.list
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  upgradeMerchant: (payloads) => {
    const url = api.merchant.upgrade
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  getApiKeyStatus: (merchantId) => {
    const url = api.merchant.apiKeyStatus(merchantId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateApiKeyStatus: (merchantId, payloads) => {
    const url = api.merchant.apiKeyActive(merchantId)
    return baseURL.patch(url, payloads, { headers: getAuthHeader() })
  },
  editMerchant: (merchantId, payloads) => {
    const url = api.merchant.detail(merchantId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deleteMerchant: (merchantId) => {
    const url = api.merchant.detail(merchantId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  selfRegistration: (params) => {
    const url = api.merchant.selfRegistration + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  resendVerification: (registerId) => {
    const url = api.merchant.resendVerification(registerId)
    return baseURL.post(url, {}, { headers: getAuthHeader() })
  }
}
export default merchant
